import { useAtomValue } from 'jotai';

import { PromotionGroupImage, Wrapper } from './avatar_with_marker.styles';

import Avatar from './avatar';

import { vendorCardPromotionGroupsState } from '../../store';

import promotionGroupMarker from '../../static/promotion_group_marker.svg';

import type { User } from '@rewardopl/types';

type AvatarWithMarkerProps = {
  size?: number;
  user: User;
};

export default function AvatarWithMarker(props: AvatarWithMarkerProps) {
  const { user, size = 60 } = props;

  const cardPromotionGroups = useAtomValue(vendorCardPromotionGroupsState);

  const promotionGroup = cardPromotionGroups.find((currentPromotionGroup) =>
    currentPromotionGroup.user_ids?.includes(user._id),
  );

  return (
    <Wrapper>
      <Avatar {...props} />
      {promotionGroup ? (
        <PromotionGroupImage
          alt=""
          height={(18 / 60) * size}
          src={promotionGroupMarker}
          width={(19 / 60) * size}
        />
      ) : null}
    </Wrapper>
  );
}
